module.exports = __webpack_public_path__ + "static/media/Aa.a802fe0a.bmp";